// extracted by mini-css-extract-plugin
export var typingIndicator = "_op-0";